import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const AssignOwnerModal = ({ lead, owners, onClose, onAssign }) => {
  const [selectedOwner, setSelectedOwner] = useState(lead?.owner || '');

  const handleAssign = () => {
    if (selectedOwner) {
      onAssign(lead?.id, selectedOwner);
      onClose();
    }
  };

  const ownerOptions = owners?.map(owner => ({
    value: owner,
    label: owner
  }));

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center p-4 bg-background bg-opacity-80">
      <div className="bg-card rounded-lg border border-border shadow-brand-xl w-full max-w-md">
        <div className="flex items-center justify-between p-6 border-b border-border">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg bg-primary bg-opacity-10 flex items-center justify-center">
              <Icon name="UserPlus" size={20} color="var(--color-primary)" />
            </div>
            <div>
              <h3 className="font-heading font-semibold text-foreground text-lg">
                Assign Owner
              </h3>
              <p className="text-sm caption text-muted-foreground">
                {lead?.name}
              </p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-muted rounded-lg transition-smooth"
            aria-label="Close modal"
          >
            <Icon name="X" size={20} />
          </button>
        </div>

        <div className="p-6">
          <Select
            label="Select Owner"
            description="Choose a sales representative to manage this lead"
            options={ownerOptions}
            value={selectedOwner}
            onChange={setSelectedOwner}
            placeholder="Select an owner"
            searchable
            required
          />
        </div>

        <div className="flex gap-3 p-6 border-t border-border">
          <Button
            variant="outline"
            onClick={onClose}
            className="flex-1"
          >
            Cancel
          </Button>
          <Button
            variant="default"
            onClick={handleAssign}
            disabled={!selectedOwner}
            iconName="Check"
            iconPosition="left"
            className="flex-1"
          >
            Assign Owner
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AssignOwnerModal;